function createErrorMessage(err) {
  const apiError = {};
  if (err.response) {
    const {
      data,
    } = err.response;
    if (data) {
      const {
        message,
      } = data;
      apiError.createErr = message;
    }
  }
  return apiError;
}

export default createErrorMessage;
